import { createSelector } from '@reduxjs/toolkit';
import { Decimal } from 'decimal.js';

const getLevels = (state) => state.pointsBurnTiers.levels;
export const getPointsLevels = createSelector(getLevels, (levels) =>
  levels.map((level) => ({ min: new Decimal(level.min), max: new Decimal(level.max || Infinity), rate: new Decimal(level.rate) })),
);
export const getInstanceName = (state) => state.pointsBurnTiers.name;
export const getPointsConversion = (state) => state.pointsBurnTiers;
